import React, { Component } from 'react';
import  {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import { useContext } from 'react';
import { useShop } from './shopinfo';
import { AuthContext } from './authcontext';
import HeaderContact from './user_header_contact';




const Header = () => {
 
    const { shopData } = useShop();

    const {loggedIn} = useContext(AuthContext);

   

    //console.log("Current shop data:", shopData); 

    //console.log("Current shop pgid:", shopData.pgid); 

    if (!shopData) return (
        <div className="contentContainer">
                    <div className="headerContainer">
                        <div className="headerLeft">
                            <div className='logo'>
                                <Link to="/">
                                    
                                </Link>
                            </div>
                            <div className='firmenName'>
                                Demo-Pressewebshop<br/>
                                Version dev.202504
                            </div>
                        </div>
                        <div className="headerRight">
                            <div className='firmenDaten'>
                                <HeaderContact/>
                         
                            </div>
                            
                        </div>

                

                    </div>
        </div>            
    );

    return (  
            <div className="contentContainer">
                <div className="headerContainer">
                    <div className="headerLeft">
                        <div className='logo'>


                        {!loggedIn ? (
                                <Link to="/">
                               
                                   <img src={`https://www.pressewebshop2.de/images/${shopData.pgid}/header.png/`} alt=''/>
                                </Link>
                            ) : (
                                <Link to="/suche">
                               
                                <img src={`https://www.pressewebshop2.de/images/${shopData.pgid}/header.png/`} alt=''/>
                            </Link>
                            )}




                        </div>
                       
                    </div>
                    <div className="headerRight">
                        <div className='firmenDaten'>
                            <HeaderContact />
                    
                        </div>
                        
                    </div>

            

                </div>
         </div> 

    )
}

export default Header;    


